import { renderPipeline, renderRunnableTube } from "./main.tsx";

window.renderPipeline = renderPipeline;
window.renderRunnableTube = renderRunnableTube;
